// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f09ef173/" + chunkId + "." + __webpack_require__.h() + ".vf09ef173.js";
};